<template>
  <div class="detailUserMessage">
    <!--新增-->
    <el-dialog
      :title="$t('messageType.form.userMessageDetailTitle')"
      :visible.sync="dialogAdd"
      :close-on-click-modal="false"
      width="500px"
    >
      <el-form label-width="auto" :model="addList" ref="addList" :label-position="'right'">
        <el-form-item :label="$t('messageType.form.title')">
          <el-input v-model="addList.title" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item :label="$t('messageType.form.content')">
          <el-input v-model="addList.content" :disabled="true"></el-input>
        </el-form-item>
      </el-form>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button @click="dialogAdd = false">取 消</el-button>
      </div> -->
    </el-dialog>
  </div>
</template>
<script>
  import API from '@/api/messageCenter/userMessage.js';
  export default {
    name: 'detailUserMessage',
    data() {
      return {
        dialogAdd: false,
        addList: {},
      };
    },
    methods: {
      openDialog(flag, id) {
        if (this.$refs['addList']) {
          this.$refs['addList'].resetFields();
        }
        this.dialogAdd = flag;
        this.getDetail(id);
      },
      getDetail(id) {
        this.$axios.post(API.USER_MESSAGE_DETAIL_API + id).then((res) => {
          if (0 != res.data.code) {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'error',
            });
          } else {
            this.$emit('getData');
            this.addList = res.data.data;
          }
        });
      },
    },
  };
</script>
